/* ELLESANTI · tema V3 · scheda prodotto (prototipo V8). Nessuna libreria. CTRL+G · 29/09/2026.
   Colore e taglia (la galleria mostra le foto del colore, still life e indossate alternate), «Vedi tutte le foto», galleria mobile
   con contatore e invito a scorrere, foto a tutto schermo, aggiunta al carrello senza cambiare pagina («Aggiunto al carrello»,
   spedizione gratuita), barra d'acquisto che compare e si aggancia nella chiusura, passaggi del percorso, condividi, recensioni.
   Le guide alle taglie e alle misure sono in v3-livelli.js (EllesantiV3.guida); il cambio di colore manda l'evento «ellesanti:variante». */
(function () {
  'use strict';
  var H = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* 09/10: il numero del carrello conta i gioielli, non le confezioni regalo */
  function nGio(c) { var n = (c && c.item_count) || 0; ((c && c.items) || []).forEach(function (x) { if (x.handle === 'confezione-regalo') n -= x.quantity; }); return n; }
  var ANIM = H.classList.contains('e-anim');
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };
  var PAT = ['s', 'a', 'a', 's', 's', 'a', 'a', 's'];

  function sblocca() { if (window.EllesantiV3 && EllesantiV3.sblocca) EllesantiV3.sblocca(); else H.classList.remove('e-lock'); }

  function fmt(c, cur) {
    var n = c / 100;
    if (!cur || cur === 'EUR') return (n % 1 === 0 ? String(n) : n.toFixed(2).replace('.', ',')) + ' €';
    try { return new Intl.NumberFormat(H.lang || 'it', { style: 'currency', currency: cur }).format(n); } catch (e) { return n.toFixed(2) + ' ' + cur; }
  }

  function initScheda(root) {
    if (!root || root._e) return;
    var js = $('[data-e-scheda-json]', root);
    if (!js) return;
    var D;
    try { D = JSON.parse(js.textContent); } catch (e) { return; }
    root._e = true;
    /* le traduzioni e il nome arrivano già in HTML (l&#39;): qui servono come testo semplice */
    var dec = function (s) { return String(s == null ? '' : s).replace(/&(#39|#x27|quot|lt|gt|amp);/g, function (m, k) { return { '#39': "'", '#x27': "'", quot: '"', lt: '<', gt: '>', amp: '&' }[k]; }); };
    D.t = D.t || {};
    Object.keys(D.t).forEach(function (k) { D.t[k] = dec(D.t[k]); });
    if (D.guida && D.guida.nome) D.guida.nome = dec(D.guida.nome);
    var V = D.variants || [], O = D.values || [];
    var form = $('[data-e-form]', root), vid = $('[data-e-vid]', root);
    var BTNS = $$('[data-e-add],[data-e-now]', root);
    var gal = $('[data-e-gal]', root), galg = $('[data-e-gal-g]', root);
    var hint = $('[data-e-gal-hint]', root);

    /* stato: il valore scelto per ogni opzione (la taglia può partire vuota) */
    var start = V.filter(function (v) { return String(v.id) === (vid ? vid.value : ''); })[0] || V[0];
    var sel = start ? start.o.slice() : [];
    var tgOk = !D.scegliTg;
    if (D.os > -1 && D.scegliTg) sel[D.os] = null;

    function find(opts, strict) {
      var best = null;
      for (var i = 0; i < V.length; i++) {
        var v = V[i], ok = true;
        for (var k = 0; k < v.o.length; k++) { if (opts[k] != null && v.o[k] !== opts[k]) { ok = false; break; } }
        if (!ok) continue;
        if (strict) { if (opts.every(function (x) { return x != null; })) return v; continue; }
        if (!best || (!best.a && v.a)) best = v;
        if (best.a) break;
      }
      return best;
    }

    /* ---------------------------------------------------------------- galleria */
    /* foto per colore, come nel tema Gario: la foto si vede se i suoi valori (id uniti da «-», «*0» = in comune)
       sono quelli scelti per le opzioni del gruppo (group_media_obj.options) */
    var GO = D.gopts || [];
    function selVals() {
      return GO.map(function (oi) {
        var name = sel[oi] != null ? sel[oi] : (start ? start.o[oi] : ''), list = O[oi] || [];
        for (var i = 0; i < list.length; i++) if (list[i].n === name) return list[i].id;
        return '';
      });
    }
    function inGroup(mv, arr, sv) {
      if (!mv || mv === 'x') return false;
      if (mv === sv) return true;
      /* più colori per la stessa foto: «id|id|id» */
      if (mv.indexOf('|') > -1) return mv.split('|').indexOf(sv) > -1;
      if (mv.indexOf('*') < 0) return false;
      return mv.replace('*0', arr[0] || '').replace('*1', arr[1] || '').replace('*2', arr[2] || '') === sv;
    }
    var fmOn = /[?&]variant=/.test(location.search);
    function layout(anim) {
      if (!galg) return;
      var figs = $$('.e-gi', galg), arr = D.gm ? selVals() : [], sv = arr.join('-');
      var S = [], A = [], all = [];
      figs.sort(function (a, b) { return (+a.getAttribute('data-i')) - (+b.getAttribute('data-i')); });
      figs.forEach(function (f) {
        var ok = !D.gm || inGroup(f.getAttribute('data-v') || '', arr, sv);
        f._ok = ok;
        if (!ok) return;
        all.push(f);
        (f.getAttribute('data-s') === '1' ? S : A).push(f);
      });
      var ord = [];
      if (D.ordine === 'alterna') {
        var si = 0, ai = 0;
        PAT.forEach(function (t) { if (t === 's' && si < S.length) ord.push(S[si++]); else if (t === 'a' && ai < A.length) ord.push(A[ai++]); });
        ord = ord.concat(A.slice(ai), S.slice(si));
      } else ord = all;
      /* senza foto per colore (group media): la foto della variante scelta va in testa */
      if (!D.gm) {
        var cv = root._any || start, fm = cv && cv.fm != null ? cv.fm : -1;
        galg._fm = fm;
        if (fmOn && fm > -1) for (var j = 1; j < ord.length; j++) if (+ord[j].getAttribute('data-i') === fm) { ord.unshift(ord.splice(j, 1)[0]); break; }
      }
      var apply = function () {
        figs.forEach(function (f) { f.hidden = !f._ok; f.style.order = ''; f.classList.remove('is-extra'); });
        ord.forEach(function (f, i) {
          f.style.order = i;
          f.classList.toggle('is-extra', i >= D.max);
          var im = $('img', f);
          if (im && i < 2) im.loading = 'eager';
        });
        $$('[data-e-gal-n]', root).forEach(function (e) { e.textContent = ord.length; });
        var more = $('[data-e-gal-more]', root);
        if (more) more.hidden = ord.length <= D.max;
        galg._ord = ord;
        if (!mqDesk.matches) { galg.scrollLeft = 0; mgal(); }
      };
      if (anim && ANIM) {
        galg.classList.add('is-swap');
        setTimeout(function () { apply(); requestAnimationFrame(function () { requestAnimationFrame(function () { galg.classList.remove('is-swap'); }); }); }, 180);
      } else apply();
    }
    function visibili() { return (galg && galg._ord) ? galg._ord : $$('.e-gi:not([hidden])', galg); }
    var more = $('[data-e-gal-more]', root);
    if (more) more.addEventListener('click', function () { gal.classList.add('is-all'); });

    /* mobile: contatore, barra, invito a scorrere (sparisce al primo gesto) */
    function mgal() {
      if (!galg || mqDesk.matches) return;
      var ord = visibili(), n = ord.length || 1, c = ord[0];
      var step = c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(galg).columnGap) || 0) : galg.clientWidth || 1;
      var i = Math.min(n - 1, Math.round(galg.scrollLeft / step));
      var gi = $('[data-e-gal-i]', root); if (gi) gi.textContent = i + 1;
      var bar = $('[data-e-gal-bar]', root); if (bar) { bar.style.width = (100 / n) + '%'; bar.style.transform = 'translateX(' + (i * 100) + '%)'; }
      if (hint && galg.scrollLeft > 8) hint.classList.add('is-off');
    }
    if (galg) galg.addEventListener('scroll', mgal, { passive: true });

    /* ---------------------------------------------------------------- colore e taglia */
    function setLabels(v) {
      if (D.oc > -1) $$('[data-e-colab]').forEach(function (e) { e.textContent = sel[D.oc] || ''; });
      $$('[data-e-tglab]', root).forEach(function (e) { var k = +e.getAttribute('data-e-tglab'); e.textContent = sel[k] != null ? sel[k] : '—'; });
      $$('[data-e-addtg]').forEach(function (e) { e.textContent = D.os > -1 && sel[D.os] != null ? sel[D.os] : ''; });
      if (!v) return;
      $$('[data-e-prezzo]').forEach(function (e) { e.textContent = v.pf; });
      $$('[data-e-was]', root).forEach(function (e) { e.textContent = v.cf || ''; e.hidden = !v.cf; });
      $$('[data-e-peso]', root).forEach(function (e) { if (v.w > 0) e.textContent = v.w + ' g'; });
      if (v.img) $$('.e-sbar__img,[data-e-addimg]').forEach(function (im) { im.src = v.img; im.removeAttribute('srcset'); });
    }
    function avail(v) {
      var ok = !!(v && v.a);
      BTNS.forEach(function (b) { b.disabled = !ok; });
      var l = $('[data-e-add-l]', root);
      if (l) { if (!l._t) l._t = l.textContent; l.textContent = ok ? l._t : D.t.na; }
      /* valori non disponibili con le altre scelte */
      $$('[data-e-opt]', root).forEach(function (box) {
        var k = +box.getAttribute('data-e-opt');
        $$('[data-e-val]', box).forEach(function (b) {
          var o = sel.slice(); o[k] = b.getAttribute('data-e-val');
          var w = find(o, false);
          b.classList.toggle('is-na', !(w && w.a));
        });
      });
    }
    function update(anim) {
      var full = find(sel, true), any = full || find(sel, false);
      if (vid && full) vid.value = full.id;
      setLabels(any);
      avail(any);
      if (anim && full && history.replaceState && root.getAttribute('data-e-url') !== '0') {
        try { var u = new URL(location.href); u.searchParams.set('variant', full.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      }
      root._v = full || null;
      root._any = any;
      /* la guida alle misure (e chi altro serve) segue il colore scelto */
      if (anim) document.dispatchEvent(new CustomEvent('ellesanti:variante', { detail: { id: D.id, sel: sel.slice(), colore: D.oc > -1 ? sel[D.oc] : null, variante: full || null } }));
    }
    $$('[data-e-opt]', root).forEach(function (box) {
      var k = +box.getAttribute('data-e-opt');
      $$('[data-e-val]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var val = b.getAttribute('data-e-val');
          if (sel[k] === val && k !== D.os) return;
          sel[k] = val;
          $$('[data-e-val]', box).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (k === D.os) { tgOk = true; $$('[data-e-tgerr]', root).forEach(function (e) { e.hidden = true; }); }
          update(true);
          if (D.gm) { if (GO.indexOf(k) > -1) layout(true); }
          else if (galg && root._any && root._any.fm > -1 && root._any.fm !== galg._fm) { fmOn = true; layout(true); }
        });
      });
    });
    function needTg() {
      if (D.os < 0 || tgOk) return false;
      var box = $('[data-e-tg] .e-tgs', root), er = $('[data-e-tgerr]', root);
      if (er) er.hidden = false;
      if (box) { box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake'); }
      var r = box && box.getBoundingClientRect();
      if (r && (r.top < 80 || r.bottom > window.innerHeight)) window.scrollTo({ top: window.scrollY + r.top - 200, behavior: ANIM ? 'smooth' : 'auto' });
      return true;
    }

    /* ---------------------------------------------------------------- aggiunta al carrello */
    var panel = $('[data-e-addp]', root), dim = $('[data-e-addim]', root), lastFocus = null;
    function openPanel(item, cart, conf) {
      if (!panel) { location.href = '/cart'; return; }
      var ca = $('[data-e-addconf]', panel); if (ca) ca.hidden = !conf;
      var q = $('[data-e-addq]', panel); if (q && item) q.textContent = item.quantity;
      if (item && item.image) { var im = $('[data-e-addimg]', panel); if (im && !(root._any && root._any.img)) im.src = item.image; }
      var sp = $('[data-e-ship]', panel), bar = $('[data-e-shipbar]', panel);
      if (window.EllesantiV3 && EllesantiV3.spedizione) EllesantiV3.spedizione(cart, sp, bar);
      else {
        var tot = cart ? cart.total_price : 0, miss = D.soglia - tot;
        if (sp) sp.textContent = miss > 0 ? D.t.manca.replace('[[m]]', fmt(miss, D.cur)) : D.t.gratuita;
        if (bar) { bar.style.width = '0'; requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.width = Math.min(100, 100 * tot / (D.soglia || 1)).toFixed(1) + '%'; }); }); }
      }
      lastFocus = document.activeElement;
      panel.removeAttribute('inert'); panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('is-open'); if (dim) dim.classList.add('is-on');
      H.classList.add('e-lock');
      setTimeout(function () { var x = $('[data-e-addx]', panel); if (x) x.focus({ preventScroll: true }); }, 60);
    }
    function closePanel() {
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open'); if (dim) dim.classList.remove('is-on');
      panel.setAttribute('aria-hidden', 'true'); panel.setAttribute('inert', '');
      sblocca();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    $$('[data-e-addx]', root).forEach(function (b) { b.addEventListener('click', closePanel); });
    if (dim) dim.addEventListener('click', closePanel);
    function count(n) {
      $$('.e-hd__count, .e-bbar__count').forEach(function (c) { c.textContent = n; c.classList.toggle('is-visible', n > 0); });
    }
    function add(btn, poi) {
      if (!form || needTg()) return;
      var err = $('[data-e-add-err]', root);
      if (err) err.hidden = true;
      BTNS.forEach(function (b) { b.classList.add('is-busy'); });
      var fd = new FormData(form);
      fd.delete('return_to');
      /* 09/10 · confezione regalo: con la spunta il gioiello prende il codice _conf e subito dopo entra la confezione con lo stesso codice (_conf_di) */
      var R = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var cb = $('[data-e-conf]', form), cv = cb && cb.checked ? +cb.getAttribute('data-e-conf') : 0, cu = '';
      if (cv) { cu = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); fd.append('properties[_conf]', cu); }
      fetch(R + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (item) {
          if (!cv) return item;
          var cp = { _conf_di: cu };
          cp[dec(cb.getAttribute('data-e-conf-per') || 'Per')] = dec(cb.getAttribute('data-e-conf-nome') || item.product_title || '') + (item.variant_title ? ' · ' + item.variant_title : '');
          return fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: cv, quantity: item.quantity || 1, properties: cp }] }) })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return item; }); });
        })
        .then(function (item) {
          if (poi) { location.href = R + 'checkout'; return; }
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { count(nGio(cart)); openPanel(item, cart, !!cv); document.dispatchEvent(new CustomEvent('ellesanti:cart', { detail: cart })); });
        })
        .catch(function (e) {
          if (err) { err.textContent = (e && (e.description || e.message)) || D.t.errore; err.hidden = false; }
        })
        .then(function () { BTNS.forEach(function (b) { b.classList.remove('is-busy'); }); });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        var s = e.submitter;
        if (s && s.hasAttribute('data-e-now')) {
          if (needTg()) { e.preventDefault(); return; }
          /* «Acquista subito» con la confezione regalo: le aggiunge tutte e due, poi va al pagamento */
          var cbn = $('[data-e-conf]', form);
          if (cbn && cbn.checked) { e.preventDefault(); add(s, true); }
          return;
        }
        e.preventDefault();
        add(s);
      });
    }
    $$('[data-e-sb-add]', root).forEach(function (b) { b.addEventListener('click', function () { add(b); }); });
    /* «confezione regalo» nella spunta: apre la fisarmonica «Packaging e confezione regalo» e la porta a vista */
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-e-conf-link]');
      if (!a) return;
      var acc = document.getElementById('e-conf-regalo');
      if (!acc) return;
      e.preventDefault();
      var b = $('[data-e-acc-btn]', acc);
      if (b && !acc.classList.contains('is-open')) b.click();
      acc.scrollIntoView({ behavior: ANIM ? 'smooth' : 'auto', block: 'center' });
    });

    /* ---------------------------------------------------------------- barra d'acquisto: compare e si aggancia nella chiusura */
    var sbar = $('[data-e-sbar]', root), dock = $('[data-e-dock]'), addMain = $('[data-e-add-main]', root);
    /* REV 3.1: senza la «Chiusura» (dove la barra si agganciava) la barra resta fino al footer e lì sparisce */
    var fine = dock ? null : document.getElementById('hdt-prefooter');
    if (sbar && dock) dock.appendChild(sbar);
    var GAP = function () { return mqDesk.matches ? 20 : 12; }, sbH = 0, WA = null;
    function sb() {
      if (!sbar || !addMain) return;
      var vh = window.innerHeight, h = sbar.offsetHeight || (dock ? dock.offsetHeight : 0);
      /* l'altezza della barra (momento, nome, bottone) decide il posto nella chiusura e dove sale il bottone WhatsApp */
      if (h && h !== sbH) { sbH = h; H.style.setProperty('--e-sb-h', h + 'px'); }
      /* giro UX1 (2/10/2026): su mobile la barra c'è da subito e sparisce solo mentre il bottone principale è a vista; su desktop compare dopo il bottone */
      var ar = addMain.getBoundingClientRect();
      var past = mqDesk.matches ? ar.bottom < 0 : !(ar.top < vh && ar.bottom > 0);
      var docked = false, dr = null;
      if (dock && dock.offsetParent !== null) {
        dr = dock.getBoundingClientRect();
        docked = dr.top <= vh - GAP() - h + 0.5;
        if (!docked) { sbar.style.left = dr.left + 'px'; sbar.style.right = 'auto'; sbar.style.width = dr.width + 'px'; }
        else { sbar.style.left = ''; sbar.style.right = ''; sbar.style.width = ''; }
      }
      if (fine && past) { var fr = fine.getBoundingClientRect(); if (fr.top < vh - 8) past = false; }
      sbar.classList.toggle('is-docked', docked);
      sbar.classList.toggle('is-show', !docked && past);
      H.classList.toggle('e-sb-on', past && !docked);
      /* agganciata, la barra scorre con la pagina: il bottone WhatsApp torna al suo posto e sparisce solo finché la barra gli passa sopra */
      var off = false;
      if (docked) {
        WA = WA || document.querySelector('.e-wa');
        if (WA) { var wr = WA.getBoundingClientRect(), br = sbar.getBoundingClientRect(); off = br.left < wr.right + 12 && br.right > wr.left - 12 && br.top < wr.bottom + 12 && br.bottom > wr.top - 12; }
      }
      H.classList.toggle('e-wa-off', off);
    }
    if (sbar) { window.addEventListener('scroll', sb, { passive: true }); window.addEventListener('resize', sb); sb(); }

    /* ---------------------------------------------------------------- foto a tutto schermo (desktop) */
    var lb = $('[data-e-lb]', root), li = 0;
    function showLb(i) {
      var ord = visibili(); if (!ord.length) return;
      li = (i + ord.length) % ord.length;
      var src = $('img', ord[li]), big = $('[data-e-lb-img]', lb);
      if (src && big) { big.src = src.currentSrc || src.src; big.srcset = src.srcset || ''; big.sizes = '100vw'; big.alt = src.alt; }
      var c = $('[data-e-lb-c]', lb); if (c) c.textContent = D.t.foto.replace('[[n]]', li + 1).replace('[[t]]', ord.length);
    }
    function openLb(i) { if (!lb) return; showLb(i); lb.removeAttribute('inert'); lb.setAttribute('aria-hidden', 'false'); lb.classList.add('is-on'); H.classList.add('e-lock'); var x = $('[data-e-lb-x]', lb); if (x) x.focus({ preventScroll: true }); }
    function closeLb() { if (!lb || !lb.classList.contains('is-on')) return; lb.classList.remove('is-on'); lb.setAttribute('aria-hidden', 'true'); lb.setAttribute('inert', ''); sblocca(); }
    if (lb && galg) {
      galg.addEventListener('click', function (e) {
        if (!mqDesk.matches) return;
        var f = e.target.closest && e.target.closest('.e-gi'); if (!f) return;
        openLb(visibili().indexOf(f));
      });
      $('[data-e-lb-x]', lb).addEventListener('click', closeLb);
      $('[data-e-lb-p]', lb).addEventListener('click', function () { showLb(li - 1); });
      $('[data-e-lb-n]', lb).addEventListener('click', function () { showLb(li + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePanel(); closeLb(); }
      if (lb && lb.classList.contains('is-on')) { if (e.key === 'ArrowLeft') showLb(li - 1); if (e.key === 'ArrowRight') showLb(li + 1); }
    });

    /* ---------------------------------------------------------------- fisarmoniche aperte solo su mobile, condividi, guide */
    if (!mqDesk.matches) $$('.e-pacc.is-open-m', root).forEach(function (a) { a.classList.add('is-open'); var b = $('[data-e-acc-btn]', a); if (b) b.setAttribute('aria-expanded', 'true'); });
    $$('[data-e-share]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-url') || location.href, t = b.getAttribute('data-title') || document.title;
        if (navigator.share) { navigator.share({ title: t, url: url }).catch(function () {}); return; }
        var done = function () { var s = $('span', b); if (s) { var o = s.textContent; s.textContent = b.getAttribute('data-ok') || o; setTimeout(function () { s.textContent = o; }, 1800); } };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () {}); else done();
      });
    });
    /* guide: taglie (anelli, bracciali) e misure (collane), da v3-livelli.js; la taglia scelta nella guida si sceglie qui */
    var G = window.EllesantiV3 && window.EllesantiV3.guida, DG = D.guida || {};
    function apriGuida(k, b) {
      var tv = D.os > -1 ? (O[D.os] || []).map(function (x) { return x.n; }) : [];
      G.apri(k, {
        nome: DG.nome, fit: DG.fit, righe: DG.righe, back: b,
        colore: D.oc > -1 ? sel[D.oc] : null,
        taglie: tv,
        /* solo le taglie che si possono comprare con il colore scelto */
        disp: tv.filter(function (n) { var o = sel.slice(); o[D.os] = n; var w = find(o, false); return !!(w && w.a); }),
        scegli: function (v) { var t = $('[data-e-tg] [data-e-val="' + (window.CSS && CSS.escape ? CSS.escape(v) : v) + '"]', root); if (t) t.click(); }
      });
    }
    $$('[data-e-guida]', root).forEach(function (b) {
      var k = b.getAttribute('data-e-guida');
      if (!G || !G.ha || !G.ha(k, DG.righe)) return;
      b.hidden = false;
      var riga = b.closest('[data-e-guida-riga]'); if (riga) riga.hidden = false;
      b.addEventListener('click', function () { apriGuida(k, b); });
    });
    /* REV 3.1: la fisarmonica «Vestibilità e guida taglie» apre la guida; senza guida torna una fisarmonica con il suo titolo */
    $$('[data-e-acc-guida]', root).forEach(function (acc) {
      var k = acc.getAttribute('data-e-acc-guida'), b = $('[data-e-acc-btn]', acc), n = b && $('.e-acc__n', b);
      if (!b) return;
      if (!G || !G.ha || !G.ha(k, DG.righe)) {
        acc.classList.remove('e-pacc--guida');
        if (n) n.textContent = acc.getAttribute('data-t-acc') || n.textContent;
        return;
      }
      b.setAttribute('aria-haspopup', 'dialog');
      b.removeAttribute('aria-expanded');
      acc.addEventListener('click', function (e) {
        if (!e.target.closest || !e.target.closest('[data-e-acc-btn]')) return;
        e.stopPropagation();
        e.preventDefault();
        apriGuida(k, b);
      }, true);
    });

    update(false);
    layout(false);
    mgal();
    root._api = { add: add, update: update, layout: layout, sb: sb };
  }

  /* il percorso: la linea dei quattro passaggi si disegna quando entra */
  function initSteps(scope) {
    $$('[data-e-steps]', scope).forEach(function (s) {
      if (s._e) return;
      s._e = true;
      if (!ANIM || !('IntersectionObserver' in window)) { s.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { s.classList.add('is-in'); io.disconnect(); } }); }, { threshold: 0.35 });
      io.observe(s);
    });
  }

  /* recensioni: il widget di Judge.me resta chiuso finché non serve.
     «Scrivi una recensione» apre direttamente il modulo di Judge.me (widget nuovo: finestra sopra la pagina, il widget resta chiuso);
     con il widget classico, che ha il modulo dentro la pagina, prima si apre il widget. */
  function initRev(scope) {
    $$('[data-e-rev2]', scope).forEach(function (sec) {
      if (sec._e) return;
      sec._e = true;
      var app = $('[data-e-rev-app]', sec);
      if (!app) return;
      var open = function () { app.hidden = false; };
      var w = $('[data-e-rev-scrivi]', sec), t = $('[data-e-rev-tutte]', sec);
      if (w) w.addEventListener('click', function () {
        var m = $('.jm-action-buttons__button.jm-button--primary, [data-jm-write-review], .jm-write-review-button', app);
        if (m) { m.click(); return; }
        open();
        var l = $('.jdgm-write-rev-link', app);
        if (l) l.click();
        setTimeout(function () { app.scrollIntoView({ behavior: ANIM ? 'smooth' : 'auto', block: 'start' }); }, 60);
      });
      if (t) t.addEventListener('click', function () { open(); t.hidden = true; app.scrollIntoView({ behavior: ANIM ? 'smooth' : 'auto', block: 'start' }); });
    });
  }

  function init(scope) {
    scope = scope || document;
    $$('[data-e-scheda]', scope).forEach(initScheda);
    if (scope.matches && scope.matches('[data-e-scheda]')) initScheda(scope);
    initSteps(scope);
    initRev(scope);
  }
  window.EllesantiV3 = window.EllesantiV3 || {};
  window.EllesantiV3.hooks = window.EllesantiV3.hooks || [];
  window.EllesantiV3.hooks.push(init);
  window.EllesantiV3.scheda = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
